<template>
  <div>
    <header-elem />
    <services-elem v-if="isHomePage || isServicesPage" />
    <content-elem />
    <portfolio-elem v-if="isPortfolioPage" />
    <testimonials-elem v-if="isHomePage" />
    <gallery-elem v-if="isPortfolioPage || isAService || isSchoolsPage" />
    <contact-elem v-if="isContactPage || isAService || isSchoolsPage" />
    <clients-elem />
    <footer-elem />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex"

import api from "@/services/api"

import PortfolioElem from "@/components/Portfolio.vue"
import ContactElem from "@/components/Contact.vue"
import HeaderElem from "@/components/Header.vue"
import FooterElem from "@/components/Footer.vue"
import ClientsElem from "@/components/Clients.vue"
import TestimonialsElem from "@/components/Testimonials.vue"
import ContentElem from "@/components/Content.vue"
import ServicesElem from "@/components/Services.vue"
import GalleryElem from "@/components/Gallery.vue"

export default {
  name: "page",
  components: {
    HeaderElem,
    FooterElem,
    ClientsElem,
    TestimonialsElem,
    ContentElem,
    ServicesElem,
    ContactElem,
    PortfolioElem,
    GalleryElem
  },
  data() {
    return {}
  },
  computed: {
    ...mapState(["page"]),
    ...mapGetters(["isHomePage", "isServicesPage", "isPortfolioPage", "isContactPage", "isAService", "isSchoolsPage"])
  },
  metaInfo() {
    return {
      title: this.page.title || "SPJ Marketing",
      meta: [
        { name: "description", content: this.page.meta_desc },
        { name: "keywords", content: this.page.meta_keywords }
      ]
    }
  },
  created: function() {
    var route = this.$route
    var url = route.params.url
    var promises = []
    var store = this.$store
    var state = this.$store.state

    if (!url) store.commit("setPage", {})

    if (route.name == "404") this.page = { main_text: "Sorry, this page cannot be found!" }

    if (route.name == "page-by-url") promises.push(api.getPageByURL(url))
    if (route.name == "root") promises.push(api.getHomePage())

    Promise.all(promises).then(vals => {
      var returnedpage = vals[0]
      store.commit("setPage", returnedpage)

      if (!returnedpage || !returnedpage.ItemID)
        store.commit("setPage", { main_text: "Sorry, this page cannot be found!" })

      if (!this.isHomePage && (!this.page.banners || !this.page.banners.length))
        api.getPageByItemID(state.aboutID, "banners").then(about => this.$set(this.page, "banners", about.banners))

      if (this.page.ParentID) store.dispatch("getParentPage")
      else store.commit("setParentPage", null)

      this.$nextTick().then(() => {
        window.onscroll = function() {
          var header = document.getElementById("top")

          if (window.pageYOffset > 100) {
            header.classList.add("contrast")
          } else {
            header.classList.remove("contrast")
          }
        }
      })
    })

    store.dispatch("getSettings")
    store.dispatch("getMainPages")
  }
}
</script>
